module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0",
      "height": "auto !important"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "background-color": "#000",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.jump()
      }
    }
  }, [_vm._v("\n        2下一步3\n       ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c50f31c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/331/ApplyFormStep2.vue
// module id = 2494
// module chunks = 0